export default __webpack_public_path__ + "static/media/icon-arrow-hint.3693709b.svg";